// removed by extract-text-webpack-plugin
module.exports = {"base":"Paging_base--2HNVX","current":"Paging_current--3RFjc","total":"Paging_total--3TTNL"};


//////////////////
// WEBPACK FOOTER
// ./containers/MigrationScreen/components/Slider/components/Paging/Paging.scss
// module id = 2179
// module chunks = 11